<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>纪检监察机关处理检举控告工作规则</h1>
        <div class="first">
          <p>纪检监察机关处理检举控告工作规则</p>
          <p>（2020年1月2日中共中央政治局常委会会议审议批准2020年1月21日中共中央办公厅发布）</p>
        </div>
        <div class="date">发布时间：2020-5-20&nbsp13:30</div>
        <div class="xh"></div>
        <div class="second">
          <strong>
            <p>第一章 总则</p>
          </strong>
          <p>第一条 为了规范纪检监察机关处理检举控告工作，保障党员、群众行使监督权利，维护党员、干部合法权益，根据《中国共产党章程》、《中国共产党党内监督条例》等党内法规和《中华人民共和国宪法》、《中华人民共和国监察法》等法律，制定本规则。</p>

          <p>第二条 坚持以马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观、习近平新时代中国特色社会主义思想为指导，增强“四个意识”、坚定“四个自信”、做到“两个维护”，深入推进全面从严治党，贯彻纪律检查委员会和监察委员会合署办公要求，依规依纪依法处理检举控告，完善党和国家监督体系，强化对权力运行的制约和监督。</p>

          <p>第三条 纪检监察机关应当认真处理检举控告，回应群众关切，发挥党和国家监督专责机关作用，保障党的理论和路线方针政策以及重大决策部署贯彻落实，为党风廉政建设、社会和谐稳定服务。</p>

          <p>第四条 任何组织和个人对以下行为，有权向纪检监察机关提出检举控告：</p>
          <p>（一）党组织、党员违反政治纪律、组织纪律、廉洁纪律、群众纪律、工作纪律、生活纪律等党的纪律行为；</p>
          <p>（二）监察对象不依法履职，违反秉公用权、廉洁从政从业以及道德操守等规定，涉嫌贪污贿赂、滥用职权、玩忽职守、权力寻租、利益输送、徇私舞弊以及浪费国家资财等职务违法、职务犯罪行为；</p>
          <p>（三）其他依照规定应当由纪检监察机关处理的违纪违法行为。</p>
          <p>第五条 纪检监察机关处理检举控告工作应当遵循以下原则：</p>
          <p>（一）实事求是。以事实为依据处理检举控告，鼓励支持检举控告人客观真实地反映情况。</p>
          <p>（二）依规依纪依法。按照党章党规党纪和宪法法律以及信访工作有关规定处理检举控告，引导检举控告人依规依法、理性有序地反映问题。</p>
          <p>（三）保障合法权利。贯彻“三个区分开来”要求，既保障检举控告人的监督权利，又查处诬告陷害行为，保护党员、干部干事创业积极性。</p>
          <p>（四）分级负责、分工处理。按照管理权限受理检举控告，建立信访举报、监督检查、审查调查、案件监督管理等部门相互配合、相互制约的工作机制。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
    GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p {
  font-weight: 600;
}
.date {
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 28px;
}
</style>